function getBasicAuth() {
    const username = String(process.env.REACT_APP_CLIENT_PORTAL_API_USERNAME)
    const password = String(process.env.REACT_APP_CLIENT_PORTAL_API_PASSWORD)

    return 'Basic ' + btoa(`${username}:${password}`)
}

export default getBasicAuth
